import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { identityToolbarActionContributors } from './toolbar-action-contributors';

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    loadChildren: () => import('./user-dashboard/user-dashboard.module').then(m => m.UserDashboardModule),
  },
  {
    path: 'account',
    loadChildren: () => import('@abp/ng.account').then(m => m.AccountModule.forLazy()),
  },
  {
    path: 'identity',
    loadChildren: () =>
      import('@abp/ng.identity').then(m =>
        m.IdentityModule.forLazy({
          toolbarActionContributors: identityToolbarActionContributors,
        })
      )
  },
  {
    path: 'setting-management',
    loadChildren: () =>
      import('@abp/ng.setting-management').then(m => m.SettingManagementModule.forLazy()),
  },
  { path: 'configuration', loadChildren: () => import('./configuration/configuration.module').then(m => m.ConfigurationModule) },
  { path: 'form', loadChildren: () => import('./form/form.module').then(m => m.FormModule) },
  { path: 'addform', loadChildren: () => import('./addform/addform.module').then(m => m.AddformModule) },
  { path: 'editform', loadChildren: () => import('./editform/editform.module').then(m => m.EditformModule) },
  { path: 'createproject', loadChildren: () => import('./create-project/create-project.module').then(m => m.CreateProjectModule) },

  // Section module - uses slug-based routes only
  { 
    path: 'section', 
    loadChildren: () => import('./section/section.module').then(m => m.SectionModule) 
  },
  
  { path: 'userdashboard', loadChildren: () => import('./user-dashboard/user-dashboard.module').then(m => m.UserDashboardModule) },
  { path: 'pm-dashboard', loadChildren: () => import('./pm-dashboard/pm-dashboard.module').then(m => m.PmDashboardModule) },
  { path: 'dynamicReport', loadChildren: () => import('./dynamic-reports/dynamic-reports.module').then(m => m.DynamicReportsModule) },
  { path: 'dropdownConfig', loadChildren: () => import('./dropdown-configs/dropdown-configs.module').then(m => m.DropdownConfigsModule) },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule],
})
export class AppRoutingModule {}
